import styled from 'styled-components'
import { Icon } from 'common-components'
import { COLORS } from 'consts/colors'

export const TtsSpeakerIcon = styled(Icon)`
  margin: 2px;
`

export const ToggleTTSSpeakerWrapper = styled.div`
  padding: 2px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2px;
  border-radius: 4px;
  background-color: transparent;
  cursor: pointer;

  @media screen and (min-width: 768px) {
    &:hover {
      background-color: ${COLORS.primarySemiLight};

      p {
        color: ${COLORS.secondaryDark};
      }

      path {
        fill: ${COLORS.secondaryDark};
      }
    }
  }
  transition:
    background-color 0.2s ease-in-out,
    color 0.2s ease-in-out,
    path 0.2s ease-in-out;
`
